module.exports = __webpack_public_path__ + "static/media/aq.47785920.svg";